import { Container, ImageInput } from 'components/atoms';
import { FormInput } from 'components/molecules';
import Gallery from 'components/molecules/gallery/Gallery';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiShoppingBag } from 'react-icons/pi';
import { IMerchMutationForm } from 'services/merch/types';
import { filterImagesByIsMainAndReturnFirst } from '../MerchForm';

const MerchImages = () => {
  const { t } = useTranslation();
  const { initialValues, values, setFieldValue } =
    useFormikContext<IMerchMutationForm>();
  return (
    <div className='flex flex-col gap-4'>
      <Container className='w-[200px]'>
        <Container.Header
          title={
            <>
              <PiShoppingBag /> {t('merch.tabs.data')}
            </>
          }
        />
        <Container.Content className='flex w-full items-center'>
          <div className='w-[200px]'>
            <ImageInput
              fullResolutionUrl={
                filterImagesByIsMainAndReturnFirst(values.gallery.images)
                  ?.imageLink
              }
              previewUrl={
                filterImagesByIsMainAndReturnFirst(values.gallery.images)
                  ?.imagePreviewLink
              }
              editable={false}
              onChange={file => setFieldValue('file', file)}
            />
          </div>
        </Container.Content>
        <Container.Content>
          <FormInput.Text
            type='number'
            name='EAN'
            label={t('input.label.ean')}
          />
        </Container.Content>
      </Container>
      <Gallery<IMerchMutationForm>
        showMainImageControls={true}
        isMainImg={initialValues.EAN.length > 0}
      />
    </div>
  );
};

export default MerchImages;
